import { ref } from '@vue/composition-api'

const defaultState = () => ({
  listingsRestore: ref({}),
})

export default defaultState
